<template>
    <v-row no-gutters>
        <v-col>
            <v-tooltip top v-if="textBiggerThanChars">
                <template v-slot:activator="{ on }">
                    <span v-on="on">{{ textFormatted }}</span>
                </template>
                <span>{{ text }}</span>
            </v-tooltip>
            <span v-else>{{ textFormatted }}</span>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: "TextLengthLimitations",
        props:['text', 'chars'],
        data(){
            return{}
        },
        computed:{
            textFormatted(){
                return this.textBiggerThanChars ? this.text.substring(0,this.chars)+'...' : this.text;
            },
            textBiggerThanChars(){
                return this.text.length > this.chars;
            }
        }
    }
</script>